'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$MeasurementsForm$() {
  this.aNd = null;
  this.aNu = null;
  this.aNg = null;
  this.aNh = false;
  this.aNm = null;
  this.aNn = false;
  this.aNs = null;
  this.aNt = false;
  this.aNe = null;
  this.aNf = false;
  this.aNq = null;
  this.aNr = false;
  this.aNo = null;
  this.aNp = false;
  this.aNi = null;
  this.aNj = false;
  this.aNk = null;
  this.aNl = false;
  $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$MeasurementsForm$ = this;
  this.aNd = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$Measurements$();
  this.aNu = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fchimney$package$().eU($m_Lapp_data_data\uff3fpoint\uff3ftypes$package$Measurements$());
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$MeasurementsForm$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$MeasurementsForm$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$MeasurementsForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$MeasurementsForm$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$MeasurementsForm$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$MeasurementsForm$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$MeasurementsForm$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$MeasurementsForm$.prototype = $p;
$p.eR = (function() {
  return this.aNd;
});
$p.eO = (function() {
  return this.aNu;
});
$p.bW = (function() {
  if ((!this.aNh)) {
    this.aNg = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aNh = true;
  }
  return this.aNg;
});
$p.b9 = (function() {
  if ((!this.aNn)) {
    this.aNm = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1(this);
    this.aNn = true;
  }
  return this.aNm;
});
$p.b3 = (function() {
  if ((!this.aNt)) {
    this.aNs = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5(this);
    this.aNt = true;
  }
  return this.aNs;
});
$p.aG = (function() {
  if ((!this.aNf)) {
    this.aNe = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(this);
    this.aNf = true;
  }
  return this.aNe;
});
$p.az = (function() {
  if ((!this.aNr)) {
    this.aNq = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aNr = true;
  }
  return this.aNq;
});
$p.aY = (function() {
  if ((!this.aNp)) {
    this.aNo = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().eS(this.az());
    this.aNp = true;
  }
  return this.aNo;
});
$p.aff = (function() {
  if ((!this.aNj)) {
    this.aNi = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Measurements";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aNj = true;
  }
  return this.aNi;
});
$p.bNz = (function() {
  if ((!this.aNl)) {
    this.aNk = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_components_TextKindFor$().zt;
    this.aNl = true;
  }
  return this.aNk;
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$MeasurementsForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$MeasurementsForm$, "app.data.data_point_types$package$MeasurementsForm$", ({
  G8: 1,
  N: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$MeasurementsForm$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$MeasurementsForm$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$MeasurementsForm$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$MeasurementsForm$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$MeasurementsForm$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$MeasurementsForm$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$MeasurementsForm$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$MeasurementsForm$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$MeasurementsForm$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$MeasurementsForm$ };
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Measurements$() {
  this.aNb = null;
  this.aNc = false;
  this.aN9 = null;
  this.aNa = false;
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Measurements$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Measurements$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Measurements$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Measurements$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$Measurements$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$Measurements$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$Measurements$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$Measurements$.prototype = $p;
$p.aA = (function() {
  if ((!this.aNc)) {
    this.aNb = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.aNc = true;
  }
  return this.aNb;
});
$p.bN9 = (function() {
  if ((!this.aNa)) {
    this.aN9 = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$MeasurementsForm$().aff();
    this.aNa = true;
  }
  return this.aN9;
});
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__validate__T__O(this, input);
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$Measurements$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Measurements$, "app.data.data_point_types$package$Measurements$", ({
  G7: 1,
  B: 1,
  C: 1,
  J: 1,
  M: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$Measurements$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$Measurements$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$Measurements$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$Measurements$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$Measurements$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$Measurements$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Measurements$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$Measurements$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$Measurements$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$Measurements$ };
//# sourceMappingURL=app.data.data_point_types$package$-Measurements$.js.map
